import { render, staticRenderFns } from "./GalleriesView.vue?vue&type=template&id=45ccca2c&scoped=true&"
import script from "./GalleriesView.vue?vue&type=script&lang=js&"
export * from "./GalleriesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ccca2c",
  null
  
)

export default component.exports